import { InferType, object, string } from 'yup'

export { provider as baseURL } from 'constants/apiBaseUrls'

export const Schema = object().shape({
  memberId: string().required(),
})

export type Request = InferType<typeof Schema>
// TODO - add type for rx list item
export type SuccessfulResponse = any[]

export const url = ({ memberId }: Request) => `/v1/members/${memberId}/prescriptions`
